module.exports = __webpack_public_path__ + "static/media/derecho-sucesorio.4fd339d9.jpg";